import { BeRadio, BeRow } from "@beos-css/react/index.ts";
import { useState } from "react";

export function RadioDemo() {
	const [diet, setDiet] = useState("omnivore");

	return (
		<section id="demo-radio">
			<h2>Radio (BRadioButton)</h2>
			<p>
				The knob is a bitmap (recessed ring + glossy blue sphere), reproduced by render.ts like the window decor buttons. Press for the
				ellipse ring; tab for the focus underline.
			</p>
			<BeRow wrap gap="row">
				<BeRadio name="diet" value="omnivore" checked={diet === "omnivore"} onChange={() => setDiet("omnivore")}>
					Omnivore
				</BeRadio>
				<BeRadio name="diet" value="veg" checked={diet === "veg"} onChange={() => setDiet("veg")}>
					Vegetarian
				</BeRadio>
				<BeRadio name="diet2" defaultChecked disabled>
					Disabled (on)
				</BeRadio>
				<BeRadio name="diet2" disabled>
					Disabled (off)
				</BeRadio>
			</BeRow>
		</section>
	);
}
